import Vue from 'vue';

class Http {
  get(url, params) {
    return Vue.axios.get(url, { params }).then(res => res.data);
  };

  post(url, body, config) {
    return Vue.axios.post(url, body, config).then(res => res.data);
  };

  put(url, body, config) {
    return Vue.axios.put(url, body, config).then(res => res.data);
  }
};

export default new Http();



// WEBPACK FOOTER //
// ./src/service/http.js